import { ModalConfirmation } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../enums/modalId'

export interface DeleteProductUnitsConfirmationModalProps {
  unit?: string
  onClose: () => void
  onDelete: (unit: string) => void
}

export const DeleteProductUnitsConfirmationModal = ({
  onClose,
  onDelete,
  unit,
}: DeleteProductUnitsConfirmationModalProps) => {
  const { t } = useTranslation()

  const handleOkClick = useCallback(() => {
    if (unit) {
      onDelete(unit)
    }
  }, [onDelete, unit])

  return (
    <ModalConfirmation
      id={ModalId.DeleteProductUnitsConfirmationModal}
      size="s"
      danger={true}
      title={t('products.product_units_modal.delete.title', { unit })}
      cancelLabel={t('products.product_units_modal.delete.actions.cancel')}
      okLabel={t('products.product_units_modal.delete.actions.confirm')}
      onOk={handleOkClick}
      onCancel={onClose}
    />
  )
}
